<!-- Don't use this directly, use IconTvDecoder instead. -->

<template>
  <svg
    id="svg1999"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    version="1.1"
    sodipodi:docname="icon_tv_portrait_slaves.svg"
    inkscape:version="1.1 (c4e8f9e, 2021-05-24)"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <defs id="defs2003" />
    <sodipodi:namedview
      id="namedview2001"
      pagecolor="#ffffff"
      bordercolor="#666666"
      borderopacity="1.0"
      inkscape:pageshadow="2"
      inkscape:pageopacity="0.0"
      inkscape:pagecheckerboard="0"
      showgrid="true"
      inkscape:snap-global="false"
      showguides="true"
      inkscape:guide-bbox="true"
      inkscape:zoom="22.627417"
      inkscape:cx="27.776038"
      inkscape:cy="11.136932"
      inkscape:window-width="1920"
      inkscape:window-height="1043"
      inkscape:window-x="1920"
      inkscape:window-y="0"
      inkscape:window-maximized="1"
      inkscape:current-layer="svg1999"
    >
      <inkscape:grid
        id="grid2024"
        type="xygrid"
      />
      <sodipodi:guide
        id="guide2026"
        position="4.4857626,22.425367"
        orientation="1,0"
      />
      <sodipodi:guide
        id="guide2028"
        position="10.838621,23.204505"
        orientation="0,-1"
      />
    </sodipodi:namedview>
    <g
      id="g2370"
      transform="matrix(0.87588721,0,0,0.87588721,0.55850754,2.8670054)"
    >
      <path
        id="path1997"
        d="m 4.6,14.8 v 4.6 c 0,1 0.8,1.8 1.9,1.8 h 1.9 v 1.9 h 7.4 v -1.9 h 1.9 c 1,0 1.9,-0.8 1.9,-1.9 V 2.7 c 0,-1 -0.8,-1.9 -1.9,-1.9 H 6.4 c -1,0 -1.9,0.8 -1.9,1.9 V 7.3 M 6.6,19.1 V 3 h 10.7 v 16.1 z"
      />
      <path
        id="path1997-2"
        d="m 9.78125,-2.4121094 c -1,0 -1.9003906,0.8003907 -1.9003906,1.90039065 v 0.53125 H 9.9804688 V -0.21289062 H 20.679688 V 15.888672 h -0.177735 v 2.099609 h 0.578125 c 1,0 1.900391,-0.80039 1.900391,-1.90039 V -0.51171875 c 0,-0.99999995 -0.800391,-1.90039065 -1.900391,-1.90039065 z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconTvPortraitSlaves',
};
</script>

<style scoped>
svg {
  fill: currentColor;
  max-width: 24px;
  max-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/IconTvPortraitSlaves.vue